var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isCompanion
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$i18n.auth.session_expired_companion) +
                "\n    "
            )
          ])
        : _c("div", { staticClass: "login-page" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-5 col-sm-12 col-xs-12 well" },
                [
                  _c("login-form", {
                    attrs: { "login-action": _vm.loginAction, user: _vm.user }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6 col-md-offset-3 text-center" },
                    [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$i18n.auth.already_connected))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("social-login", {
                            attrs: {
                              "fa-icon": "fab fa-facebook-f",
                              text: "Login with Facebook",
                              "login-action": _vm.loginWithFacebook
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("social-login", {
                            attrs: {
                              "fa-icon": "fa fa-lock",
                              text: "Login with Multibrain",
                              "login-action": _vm.loginWithMultibrain
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]),
      _vm._v(" "),
      _c("language-selector")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6 col-md-offset-3 text-center logo-login" },
        [_c("div", { attrs: { id: "logo-image" } })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69787b62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69787b62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/login.vue
// module id = 1269
// module chunks = 4